import { FC, SVGProps } from 'react';

const IconLightGrayPlus: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <path d="M6 2V10M2 6H10" stroke="#5B5D63" strokeWidth="1.28571" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default IconLightGrayPlus;
